import { Injectable } from '@angular/core';
import { AccountsService } from '../accounts/accounts.service';
import { ToastService } from '../toast/toast.service';
import { GlobalFilterService } from '../filters/global-filter.service';
import * as moment from 'moment';
import { AsyncSubject, BehaviorSubject, filter, Observable, ReplaySubject, Subject } from 'rxjs';
import * as _ from 'lodash';
import { SideBarConfigs, FirstTabConfigs } from '../../components/side-bar-v2/config';
import { environment } from 'src/environments/environment';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
@Injectable({
  providedIn: 'root'
})
export class HelpersService {
  helpers: any = {
    hasProperty: this.hasProperty,
    getBrandDetails: this.getBrandDetails.bind(this),
    getHierarchyStack: this.getHierarchyStack.bind(this),
    getRandomString: this.getRandomString,
    getDefaultLabelConfigs: this.getDefaultLabelConfigs,
    getDisplayLabel: this.getDisplayLabel.bind(this),
    getFieldDeviation: this.getFieldDeviation.bind(this),
    getDeviationComparisonLabel: this.getDeviationComparisonLabel.bind(this),
    getNps: this.getNps,
    getColumnsWithDeviation: this.getColumnsWithDeviation,
    INRCurrencyPipeFilter: this.INRCurrencyPipeFilter,
    isReportDownloadEnabled: this.isReportDownloadEnabled.bind(this),
    getNumericValueToFormatedString: this.getNumericValueToFormatedString.bind(this),
    restrictedBrandsForCustomerNames: ['570f22b9c11c7dfa196b38e3', '56efd13359205e5c1935c6c4'],
    deepClone: this.deepClone,
    smallAlertBox: (msgHeader: string, msgDetail: string, msgType: string, duration?: number) => {
      this.smallAlertBox(msgHeader, msgDetail, msgType, duration);
    },
    showConfirmationBox: (title: string, content: string, cb: any) => {
      this.showConfirmationBox(title, content, cb)
    },
    SmartMessageBox: (detail: any, cb: any) => {
      this.smartMessageBox(detail, cb)
    },
    finalTimeInMinForSLA: this.finalTimeInMinForSLA.bind(this),
    getSlaClosureFinalDate: this.getSlaClosureFinalDate.bind(this),
    getProperStringSLA: this.getProperStringSLA.bind(this),
    removeSpecialCharacters: this.removeSpecialCharacters.bind(this),
    getUniversalFilter: this.getUniversalFilter.bind(this),
    setUniversalFilter: this.setUniversalFilter.bind(this),
    resetAppState: this.resetAppState.bind(this),
    getRaterDetails: this.getRaterDetails.bind(this),
    isTabVisible: (isAccount: boolean, moduleName: string, subModuleName?: string) => {
      return this.isTabVisible(isAccount, moduleName, subModuleName);
    },
    isValidJSON: this.isValidJSON.bind(this),
    generateColor: (colorStart, colorEnd, colorCount) => {
      return this.generateColor(colorStart, colorEnd, colorCount)
    },
    _objectWithoutProperties: this._objectWithoutProperties.bind(this)
  };
  // This object is used to hold/store formated module config for account and project.
  moduleConfig: any = {
    'account': {},
    'project': {},
  }

  private datePickerSource = new BehaviorSubject<any>({});
  datePicker = new ReplaySubject<any>(1);;
  private appStateSource = new BehaviorSubject<any>({ pending: true });
  // appState = this.appStateSource.asObservable();
  // private tempAppStateSource = new BehaviorSubject<any>({});
  appStatesSubscriber: any;
  appState = new ReplaySubject<any>(1);

  projectType = new BehaviorSubject<any>({});
  isReload: boolean = false;
  messageBox: any = new Subject<any>();

  constructor(private _toast: ToastService, private globalFilterService: GlobalFilterService, private appStateService: AppStateService) { }
  deepClone(data: any) {
    if (data) {
      return JSON.parse(JSON.stringify(data));
    } else {
      return data;
    }

  }
  // Getting dateFilterObject from header component
  setDateFilterDetails(dateFilterDetails: any) {
    this.helpers['datePicker'] = dateFilterDetails
  }

  setInitialData(accountDetails?: any, queryParamsObject?: any, managerAccess?: any, brandDetails?: any) {
    let currentValue: any = this.appStateSource.value;
    if (accountDetails && !_.isEmpty(accountDetails)) {
      this.helpers['accountDetails'] = accountDetails;
      currentValue['accountDetails'] = accountDetails;
    }
    if (brandDetails && !_.isEmpty(brandDetails)) {
      this.helpers['brandDetails'] = brandDetails;
      currentValue['brandDetails'] = brandDetails;
      const mapping = this.getHierarchyMapping(brandDetails);
      this.helpers['hierarchyMapping'] = mapping.hierarchyMapping;
      this.helpers['hierarchyFilterMapping'] = mapping.hierarchyFilterMapping;

    }
    if (queryParamsObject && !_.isEmpty(queryParamsObject)) {
      this.helpers['accessObject'] = queryParamsObject;
      currentValue['accessObject'] = queryParamsObject;
    }
    if (managerAccess && !_.isEmpty(managerAccess)) {
      this.helpers['managerAccess'] = managerAccess;
      currentValue['managerAccess'] = managerAccess;
    }
    // this.appStateSource.next(currentValue);
    this.updateAppState(currentValue, true)
  }
  getHierarchyMapping(brandDetail: any) {
    let hierarchyMapping: any = {};
    let hierarchyFilterMapping: any = []
    if (brandDetail && _.hasIn(brandDetail, 'hierarchy_list') && !_.isEmpty(brandDetail.hierarchy_list)) {
      _.each(brandDetail.hierarchy_list, (value: any, key: string) => {
        if (key != 'default' && _.isEmpty(hierarchyMapping)) {
          _.each(value, (item: string, ind: any) => {
            const level = brandDetail.hierarchy_list_alias[key].values[ind];
            hierarchyMapping[level] = item
            hierarchyFilterMapping.push({
              "key": level,
              "label": item,
              "options": [
                "ALL"
              ],
              "value": "ALL",
              "enabled": false
            })
          })
        }
      })

    }
    return { hierarchyMapping, hierarchyFilterMapping };
  }

  /**
   * Checks if a tab should be visible based on module configuration
   * @param tabKey - The tab key to check
   * @param moduleConfigs - Module configuration object
   * @returns True if tab should be visible
   */
  checkTabVisiblity(tabKey: string, moduleConfigs: any) {
    const isTabEnabled = (tabKey && _.has(moduleConfigs, tabKey + '.enabled') && _.get(moduleConfigs, tabKey + '.enabled') == true);
    const isTabVisible = (tabKey && _.has(moduleConfigs, tabKey + '.visible') && _.get(moduleConfigs, tabKey + '.visible') == true);
    return (isTabEnabled && isTabVisible) ? true : false;
  }

  /**
   * Gets the active side menu based on account/project context
   * @param isAccount - True if in account context, false for project context
   * @param config - Optional module configuration
   * @returns Array of menu items to display
   */
  getActiveSideMenu(isAccount: boolean, accountId?: string, config?: any) {
    let menuItems: any = [];
    let moduleConfigs: any = {};
    // Add settings menu with submenu for developers
    const managerId: string = _.get(this.helpers, 'managerDetails.manager.email_address')
    const isAccountManager = this.checkForAccountManagerAccess(_.get(this.helpers, 'managerDetails.manager.manager_access'), accountId);
    if (isAccount) {
      // Handle account-level menu items
      moduleConfigs = (config && !_.isEmpty(config)) ? config : _.get(this.helpers, 'moduleConfigs.account.mainMenu', {});
      if (!_.isEmpty(moduleConfigs)) {
        menuItems = []
        _.each(_.cloneDeep(SideBarConfigs.account), (menu: any) => {
          if (this.checkTabVisiblity(menu.tabKey, moduleConfigs) || (this.isRelationshipViewEnabled(menu.tabKey, managerId, isAccountManager)) || menu.tabKey == 'home') {
            if (moduleConfigs && moduleConfigs[menu.tabKey] && !_.isEmpty(moduleConfigs[menu.tabKey]) && moduleConfigs[menu.tabKey]?.firstTab && moduleConfigs[menu.tabKey]?.firstTab != '') {
              menu.firstTab = moduleConfigs[menu.tabKey]?.firstTab;
            }
            menuItems.push(menu);
          }
        })
      } else {
        menuItems = SideBarConfigs.account;
      }

      const accountSettingsTab = this.getAccountSettingsMenuItems();
      if (accountSettingsTab && !_.isEmpty(accountSettingsTab) && accountSettingsTab.visible) {
        menuItems.push(accountSettingsTab);
      }

    } else {
      // Handle project-level menu items
      moduleConfigs = (config && !_.isEmpty(config)) ? config : _.get(this.helpers, 'moduleConfigs.project.mainMenu', {});

      // Filter out huddle and action items initially
      SideBarConfigs.project = _.filter(SideBarConfigs.project, (menu: any) => {
        return (menu.tabKey !== 'huddle' && menu.tabKey !== 'action_summary_v2')
      })

      if (!_.isEmpty(moduleConfigs)) {
        _.each(this.helpers.deepClone(SideBarConfigs.project), (menu: any, index: number) => {
          if (this.helpers.isTabVisible(false, menu.tabKey)) {
            let menuItem = this.helpers.deepClone(menu);
            if (moduleConfigs[menu.tabKey] && !_.isEmpty(moduleConfigs[menu.tabKey]) && moduleConfigs[menu.tabKey]?.firstTab && !_.isEmpty(moduleConfigs[menu.tabKey]?.firstTab)) {
              menuItem.firstTab = moduleConfigs[menu.tabKey]?.firstTab;
            }
            menuItems.push(menuItem);
          }
        })
      } else {
        menuItems = SideBarConfigs.project;
      }

      // Add huddle menu if enabled
      if (moduleConfigs?.huddle && moduleConfigs?.huddle.visible) {
        menuItems.push(SideBarConfigs.huddleMenu);
      }

      // Add action menu if enabled
      if (moduleConfigs?.action_summary_v2 && moduleConfigs?.action_summary_v2.visible) {
        menuItems.push(SideBarConfigs.actionMenu);
      }
      let quickSightMenu = this.helpers.deepClone(SideBarConfigs.quickSightMenu);
      if (this.helpers.isTabVisible(false, quickSightMenu.tabKey) && moduleConfigs[quickSightMenu.tabKey] && moduleConfigs[quickSightMenu.tabKey].redirection_url && moduleConfigs[quickSightMenu.tabKey].redirection_url != '' && moduleConfigs[quickSightMenu.tabKey].redirection_url != null) {
        quickSightMenu.redirection_url = moduleConfigs[quickSightMenu.tabKey].redirection_url;
        if (moduleConfigs[quickSightMenu.tabKey] && moduleConfigs[quickSightMenu.tabKey].title && moduleConfigs[quickSightMenu.tabKey].title != '') {
          quickSightMenu.title = moduleConfigs[quickSightMenu.tabKey].title;
        }
        menuItems.push(quickSightMenu);
      }

      const settingsTab = this.getSettingsMenuItems()
      if (settingsTab && !_.isEmpty(settingsTab) && settingsTab.visible) {
        menuItems.push(settingsTab)
      }
    }

    return menuItems;
  }

  getSettingsMenuItems() {
    let adminRulesDic = _.cloneDeep(this.getPermissionDictionary('project'));
    let settingsTab: any = _.cloneDeep(SideBarConfigs?.projectSetting);
    let isSettingsMenuEnabled = _.get(environment, 'project_tabs.settings.enabled', false);
    const settingsMenuItems: any = [];
    if (settingsTab && !_.isEmpty(settingsTab) && settingsTab?.submenu && !_.isEmpty(settingsTab?.submenu)) {
      _.each(settingsTab.submenu, (value: any, key: string) => {
        if (value && value?.path && value?.path !== '') {
          const tabKey = value.path.split('/')[1];
          if (this.isSettingsMenuVisible(tabKey, adminRulesDic)) {
            settingsMenuItems.push(value);
          }
        }
      })
    }

    if (isSettingsMenuEnabled && settingsMenuItems && !_.isEmpty(settingsMenuItems)) {
      settingsTab.submenu = settingsMenuItems;
      settingsTab.visible = true;
    } else {
      settingsTab.visible = false;
    }
    return settingsTab;
  }

  getAccountSettingsMenuItems() {
    let adminRulesDic = _.cloneDeep(this.getPermissionDictionary('account'));
    let settingsTab: any = _.cloneDeep(SideBarConfigs?.accountSetting);
    const settingsMenuItems: any = [];
    if (settingsTab && !_.isEmpty(settingsTab) && settingsTab?.submenu && !_.isEmpty(settingsTab?.submenu)) {
      _.each(settingsTab.submenu, (value: any) => {
        if (value && value?.path && value?.path !== '') {
          const tabKey = value.path.split('/')[1];
          if (this.isAccountSettingsMenuVisible(tabKey, adminRulesDic)) {
            settingsMenuItems.push(value);
          }
        }
      });
    }

    if (settingsMenuItems && !_.isEmpty(settingsMenuItems)) {
      settingsTab.submenu = settingsMenuItems;
      settingsTab.visible = true;
      // Point Settings root path to first allowed submenu
      settingsTab.path = settingsMenuItems[0].path;
    } else {
      settingsTab.visible = false;
    }
    return settingsTab;
  }

  setPermissionContext(scope: 'account' | 'project', adminRules: any, adminRulesDic: any, moduleConfigs?: any): void {
    if (scope === 'account') {
      this.helpers['accountAdminRules'] = adminRules;
      this.helpers['accountAdminRulesDic'] = adminRulesDic;
      if (moduleConfigs) {
        this.helpers['accountModuleConfigs'] = moduleConfigs;
      }
    } else {
      this.helpers['projectAdminRules'] = adminRules;
      this.helpers['projectAdminRulesDic'] = adminRulesDic;
      if (moduleConfigs) {
        this.helpers['projectModuleConfigs'] = moduleConfigs;
      }
    }
    this.helpers['adminRules'] = adminRules;
    this.helpers['adminRulesDic'] = adminRulesDic;
    if (moduleConfigs) {
      this.helpers['moduleConfigs'] = moduleConfigs;
    }
    window['Helpers'] = this.consoleData();
  }

  restorePermissionContext(scope: 'account' | 'project'): boolean {
    const adminRulesDic = scope === 'account'
      ? this.helpers['accountAdminRulesDic']
      : this.helpers['projectAdminRulesDic'];
    if (!adminRulesDic || _.isEmpty(adminRulesDic)) {
      return false;
    }
    const adminRules = scope === 'account'
      ? this.helpers['accountAdminRules']
      : this.helpers['projectAdminRules'];
    const moduleConfigs = scope === 'account'
      ? this.helpers['accountModuleConfigs']
      : this.helpers['projectModuleConfigs'];
    this.setPermissionContext(scope, adminRules, adminRulesDic, moduleConfigs);
    return true;
  }

  getPermissionDictionary(scope?: 'account' | 'project'): any {
    if (scope === 'account') {
      return this.helpers['accountAdminRulesDic'] || this.helpers['adminRulesDic'] || {};
    }
    if (scope === 'project') {
      return this.helpers['projectAdminRulesDic'] || this.helpers['adminRulesDic'] || {};
    }
    return this.helpers['adminRulesDic'] || {};
  }

  // This function is used to check if the settings menu is visible based on the admin rules
  isSettingsMenuVisible(tabKey: string, adminRulesDic: any) {
    let isVisible = false;
    let subMenuENVConfigs: any = _.get(environment, 'project_tabs.settings.sub_modules', {});
    let isSubMenuEnabled = false;
    if (subMenuENVConfigs[tabKey] && subMenuENVConfigs[tabKey].enabled) {
      isSubMenuEnabled = true;
    }
    switch (tabKey) {
      case 'interaction':
        isVisible = isSubMenuEnabled && this.isConversationSetupVisible(adminRulesDic);
        break;
      case 'organisation':
        isVisible = isSubMenuEnabled && this.isManageOrganizationAccessVisible(adminRulesDic);
        break;
      case 'datasets':
        isVisible = isSubMenuEnabled && this.isDatasetCreationVisible(adminRulesDic);
        break;
      case 'tools':
        isVisible = isSubMenuEnabled && this.isToolsDataCleanupVisible(adminRulesDic);
        break;
      case 'channels':
        isVisible = isSubMenuEnabled && this.isChannelManagementVisible(adminRulesDic);
        break;
      case 'action':
        isVisible = this.isActionManagementVisible(adminRulesDic);
        break;
      default:
        isVisible = false;
        break;
    }
    return isVisible;
  }

  // Account-level settings submenu visibility based on admin rules
  isAccountSettingsMenuVisible(tabKey: string, adminRulesDic: any) {
    let isVisible = false;
    switch (tabKey) {
      case 'project':
        isVisible = this.isAccountProjectCreationVisible(adminRulesDic);
        break;
      case 'user-access':
        isVisible = this.isAccountCreateNewUserVisible(adminRulesDic);
        break;
      case 'configure-dashboard':
        isVisible = this.isAccountDashboardConfigurationVisible(adminRulesDic);
        break;
      case 'security':
        isVisible = this.isAccountSecurityVisible(adminRulesDic);
        break;
      case 'notification':
        isVisible = this.isAccountNotificationsVisible(adminRulesDic);
        break;
      case 'general':
        isVisible = this.isAccountInformationUpdateVisible(adminRulesDic);
        break;
      default:
        isVisible = false;
        break;
    }
    return isVisible;
  }

  isAccountProjectCreationVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.ACCOUNT_CREATION_NEW_PROJECT && !_.isEmpty(adminRulesDic.ACCOUNT_CREATION_NEW_PROJECT) && (adminRulesDic.ACCOUNT_CREATION_NEW_PROJECT.write || adminRulesDic.ACCOUNT_CREATION_NEW_PROJECT.read)) {
        return true;
      }
    }
    return false;
  }

  isAccountCreateNewUserVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.ACCOUNT_CREATE_NEW_USER && !_.isEmpty(adminRulesDic.ACCOUNT_CREATE_NEW_USER) && (adminRulesDic.ACCOUNT_CREATE_NEW_USER.write || adminRulesDic.ACCOUNT_CREATE_NEW_USER.read)) {
        return true;
      }
    }
    return false;
  }

  isAccountDashboardConfigurationVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.ACCOUNT_MANAGE_DASHBOARD_CONFIGURATION && !_.isEmpty(adminRulesDic.ACCOUNT_MANAGE_DASHBOARD_CONFIGURATION) && (adminRulesDic.ACCOUNT_MANAGE_DASHBOARD_CONFIGURATION.write || adminRulesDic.ACCOUNT_MANAGE_DASHBOARD_CONFIGURATION.read)) {
        return true;
      }
    }
    return false;
  }

  isAccountSecurityVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.ACCOUNT_MANAGE_SECURITY && !_.isEmpty(adminRulesDic.ACCOUNT_MANAGE_SECURITY) && (adminRulesDic.ACCOUNT_MANAGE_SECURITY.write || adminRulesDic.ACCOUNT_MANAGE_SECURITY.read)) {
        return true;
      }
    }
    return false;
  }

  isAccountNotificationsVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.ACCOUNT_MANAGE_NOTIFICATIONS && !_.isEmpty(adminRulesDic.ACCOUNT_MANAGE_NOTIFICATIONS) && (adminRulesDic.ACCOUNT_MANAGE_NOTIFICATIONS.write || adminRulesDic.ACCOUNT_MANAGE_NOTIFICATIONS.read)) {
        return true;
      }
    }
    return false;
  }

  isAccountInformationUpdateVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.ACCOUNT_MANAGE_ACCOUNT_INFOMATION_UPDATE && !_.isEmpty(adminRulesDic.ACCOUNT_MANAGE_ACCOUNT_INFOMATION_UPDATE) && (adminRulesDic.ACCOUNT_MANAGE_ACCOUNT_INFOMATION_UPDATE.write || adminRulesDic.ACCOUNT_MANAGE_ACCOUNT_INFOMATION_UPDATE.read)) {
        return true;
      }
    }
    return false;
  }

  isChannelManagementVisible(adminRulesDic: any) {
    if (!adminRulesDic || _.isEmpty(adminRulesDic)) {
      return false;
    }
    const keys = [
      'CHANNEL_MANAGE_CHANNEL_CONFIGURATION',
      'CHANNEL_MANAGE_FILTER_AND_TIMING',
      'CHANNEL_MANAGE_BLACKLIST',
      'CHANNEL_MANAGE_UNSUBSCRIBE',
      'CHANNEL_MANAGE_TAG_BASED_TEMPLATE',
    ];
    return keys.some((key) => {
      const rule = adminRulesDic[key];
      return rule && !_.isEmpty(rule) && (rule.write || rule.read);
    });
  }

  isActionManagementVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.ACTION_CONFIGURATIONS_SETUP && !_.isEmpty(adminRulesDic.ACTION_CONFIGURATIONS_SETUP) && (adminRulesDic.ACTION_CONFIGURATIONS_SETUP.write || adminRulesDic.ACTION_CONFIGURATIONS_SETUP.read)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  isConversationSetupVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.CONVERSATION_MANAGE_CONVERSATION && !_.isEmpty(adminRulesDic.CONVERSATION_MANAGE_CONVERSATION) && (adminRulesDic.CONVERSATION_MANAGE_CONVERSATION.write || adminRulesDic.CONVERSATION_MANAGE_CONVERSATION.read)) {
        return true;
      } else if (adminRulesDic.CONVERSATION_MANAGE_PUBLISH && !_.isEmpty(adminRulesDic.CONVERSATION_MANAGE_PUBLISH) && (adminRulesDic.CONVERSATION_MANAGE_PUBLISH.write || adminRulesDic.CONVERSATION_MANAGE_PUBLISH.read)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  isManageOrganizationAccessVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.MANAGE_ORGANIZATION_USER_ACCESS && !_.isEmpty(adminRulesDic.MANAGE_ORGANIZATION_USER_ACCESS) && (adminRulesDic.MANAGE_ORGANIZATION_USER_ACCESS.write || adminRulesDic.MANAGE_ORGANIZATION_USER_ACCESS.read)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  isDatasetCreationVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.MANAGE_DATASETS_CREATION && !_.isEmpty(adminRulesDic.MANAGE_DATASETS_CREATION) && (adminRulesDic.MANAGE_DATASETS_CREATION.write || adminRulesDic.MANAGE_DATASETS_CREATION.read)) {
        return true;
      }
    }
    return false;
  }

  isToolsDataCleanupVisible(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.TOOLS_DATA_CLEANUP && !_.isEmpty(adminRulesDic.TOOLS_DATA_CLEANUP) && (adminRulesDic.TOOLS_DATA_CLEANUP.write || adminRulesDic.TOOLS_DATA_CLEANUP.read)) {
        return true;
      }
    }
    return false;
  }
  checkForAccountManagerAccess(managerAccess: any, accountId?: string) {
    if (!accountId) {
      return false;
    }
    let isAccountManger = false;
    if (managerAccess && managerAccess.length > 0) {
      managerAccess.some((access: any) => {
        if (access.account_id === accountId && access.manager_type === 3) {
          isAccountManger = true;
          return true;
        }
        return false;
      })
    }

    return isAccountManger;
  }

  // this function is added as temporary solution to enable the relationship view for the managers
  isRelationshipViewEnabled(tabKey: string, managerId: string, isAccountManager: boolean) {
    let adminRulesDic = _.cloneDeep(this.getPermissionDictionary('account'));
    let accountDetails = _.cloneDeep(this.helpers?.accountDetails || {});
    let isRelationshipViewEnabled = (accountDetails && _.hasIn(accountDetails, 'relationship_view.enabled') && accountDetails.relationship_view.enabled) ? _.get(accountDetails, 'relationship_view.enabled', false) : false;
    if (isRelationshipViewEnabled && tabKey == 'relationship' && isAccountManager) {
      if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
        if (adminRulesDic.RELATIONSHIP_VIEW_TAB_SETTINGS && !_.isEmpty(adminRulesDic.RELATIONSHIP_VIEW_TAB_SETTINGS) && (adminRulesDic.RELATIONSHIP_VIEW_TAB_SETTINGS.write || adminRulesDic.RELATIONSHIP_VIEW_TAB_SETTINGS.read)) {
          return true;
        }
      }
    }
    return false;
  }

  updateAppState(state: any, invoke?: boolean) {
    state['pending'] = (this.isReload) ? !this.isReloadFinish(state) : state.pending;
    this.appStateSource.next(state);
    if (invoke) {
      window['Helpers'] = this.consoleData();
      this.appState.next(this.appStateSource.getValue());
      // this.appState.complete()
    }

  }
  isReloadFinish(state: any) {
    if (this.helpers.isAccount && state.datePicker && !_.isEmpty(state.datePicker)) {
      this.isReload = false;
      return true

    } else if (!this.helpers.isAccount && state.datePicker && !_.isEmpty(state.datePicker) && (this.helpers.isAccountManager || (this.helpers.hasAccessKeys && state.hierarchyStack) || (!this.helpers.hasAccessKeys && !_.isEmpty(state.brandDetails)))) {
      this.isReload = false;
      return true
    } else {
      return false;
    }
  }
  // Orange label next to the LW logo in the header.
  setProjectType(projectTypeObject: any) {
    this.projectType.next(projectTypeObject)
    let appstate: any = this.appStateSource.value;
    this.helpers['projectType'] = projectTypeObject;
    appstate['projectType'] = projectTypeObject;
    // this.appStateSource.next(appstate);
    this.updateAppState(appstate, true)
    this.appStateService.updateProjectType(projectTypeObject);
  }

  // update the brand details for helpers and app state
  updateBrandDetails(brandDetails: any) {
    this.helpers.brandDetails = brandDetails;
    this.appStateService.updateBrandDetails(brandDetails);
  }

  consoleData() {
    return this.helpers;
  }


  // Return converted & updated Rating to display based on extended rater type
  getPrimaryRating(options: any): any {
    const ratingMapper = {
      "3": {
        "4": {
          "1": 1,
          "2": 1,
          "3": 3,
          "4": 2,
          "5": 5,
          "6": 3,
          "8": 4,
          "10": 5
        }
      }
    };
    return (ratingMapper[options.raterType]?.[options.extendedRaterType]?.[options.rating]) || options.rating;
  }


  // * @reason to modify: 
  //            *              - Get numberOfDistribution only if the rater type is 1, 3, 10
  //            *              - Instead of accessing 'rating_levels' properties, now access 'prop' of detailed_feedback_items where field_id is 'primary_rating'
  //            *              - Custom properties NOT allowed in case where numberOfDistribution is either 3 or 2 i.e., grouped data.
  //            * @example
  //            *  - Custom properties like color, text, possible values for detractors(0-6), passives(7,8), promoters(9,10) will be hard coded properties.
  //            */
  getRatingLevels(mainRaterType: any) {
    try {
      //if brand details and detailed feedback items are available
      const brandDetail = this.helpers.brandDetail;
      if (brandDetail?.detailed_feedback_items?.length) {
        // primary question from detailed feedback items
        const primaryQuestion = brandDetail.detailed_feedback_items.find(item => item.field_id === 'primary_rating');
        if (primaryQuestion) {
          // Maping prop to the desired format
          const properties = Object.values(primaryQuestion.prop as Record<string, { active_color: string, label: string, value: number }>).map(property => ({
            color: property.active_color,
            text: property.label,
            value: property.value,
            possible_values: [property.value]
          })).sort((a, b) => b.value - a.value);
          // default rating levels based on the number of distributions
          const numDistributions = primaryQuestion.numberOfDistributions;
          if ([1, 2, 3].includes(mainRaterType) && [2, 3].includes(numDistributions)) {
            return this.getDefaultRatingLevelsByNoOfDistribution(numDistributions);
          }
          return properties.length ? properties : this.getDefaultRatingLevels(mainRaterType);
        }
      }
      // default rating levels if primary question is not available
      return this.getDefaultRatingLevels(mainRaterType);
    } catch (error) {
      console.error('Error in getRatingLevels:', error);
      return this.getDefaultRatingLevels(mainRaterType);
    }
  }

  // helper method to get default labels,color and value for primary_rating according to mainRaterType
  getDefaultRatingLevels(mainRaterType: any) {
    const ratingLevels = {
      1: [
        { text: 'Annoyed!', value: -5, color: '#c42031', possible_values: [-5] },
        { text: 'Bad experience', value: -4, color: '#ed2424', possible_values: [-4] },
        { text: 'Not satisfactory', value: -3, color: '#f05f22', possible_values: [-3] },
        { text: 'Could improve', value: -2, color: '#f48020', possible_values: [-2] },
        { text: 'Tolerable', value: -1, color: '#fab416', possible_values: [-1] },
        { text: 'It\'s okay.', value: 1, color: '#f5ea14', possible_values: [1] },
        { text: 'Nice', value: 2, color: '#bbd531', possible_values: [2] },
        { text: 'Great', value: 3, color: '#66b846', possible_values: [3] },
        { text: 'Awesome', value: 4, color: '#0b7139', possible_values: [4] },
        { text: 'Brilliant', value: 5, color: '#193419', possible_values: [5] }
      ],
      3: [
        { text: 'Detractors', color: 'red', possible_values: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Passives', color: 'orange', possible_values: [7, 8] },
        { text: 'Promoters', color: 'green', possible_values: [9, 10] }
      ],
      4: [
        { text: 'Bad Experience', value: 1, color: '#f5ea14', possible_values: [1] },
        { text: 'Could Improve', value: 2, color: '#bbd531', possible_values: [2] },
        { text: 'It\'s Okay', value: 3, color: '#66b846', possible_values: [3] },
        { text: 'Nice', value: 4, color: '#0b7139', possible_values: [4] },
        { text: 'Brilliant', value: 5, color: '#193419', possible_values: [5] }
      ],
      5: [
        { text: '1', value: 1, color: 'red', possible_values: [1] },
        { text: '2', value: 2, color: 'orange', possible_values: [2] },
        { text: '3', value: 3, color: 'green', possible_values: [3] }
      ],
      6: [
        { text: '1', value: 1, color: '#B71C1C', possible_values: [1] },
        { text: '2', value: 2, color: '#B71C1C', possible_values: [2] },
        { text: '3', value: 3, color: '#B71C1C', possible_values: [3] },
        { text: '4', value: 4, color: '#B71C1C', possible_values: [4] },
        { text: '5', value: 5, color: '#B71C1C', possible_values: [5] },
        { text: '6', value: 6, color: '#B71C1C', possible_values: [6] },
        { text: '7', value: 7, color: '#FFC107', possible_values: [7] },
        { text: '8', value: 8, color: '#FFC107', possible_values: [8] },
        { text: '9', value: 9, color: '#1B5E20', possible_values: [9] },
        { text: '10', value: 10, color: '#1B5E20', possible_values: [10] }
      ],
      10: [
        { text: '0', value: 0, color: '#B71C1C', possible_values: [0] },
        { text: '1', value: 1, color: '#B71C1C', possible_values: [1] },
        { text: '2', value: 2, color: '#B71C1C', possible_values: [2] },
        { text: '3', value: 3, color: '#B71C1C', possible_values: [3] },
        { text: '4', value: 4, color: '#B71C1C', possible_values: [4] },
        { text: '5', value: 5, color: '#B71C1C', possible_values: [5] },
        { text: '6', value: 6, color: '#B71C1C', possible_values: [6] },
        { text: '7', value: 7, color: '#FFC107', possible_values: [7] },
        { text: '8', value: 8, color: '#FFC107', possible_values: [8] },
        { text: '9', value: 9, color: '#1B5E20', possible_values: [9] },
        { text: '10', value: 10, color: '#1B5E20', possible_values: [10] }
      ]
    };
    return ratingLevels[mainRaterType] || [];
  }

  // Return rating levels based on number of distribution
  getDefaultRatingLevelsByNoOfDistribution(noOfDistributions: number) {
    const distributionMapping = {
      3: [
        { text: 'Promoters', color: 'green', possible_values: [9, 10] },
        { text: 'Passives', color: 'orange', possible_values: [7, 8] },
        { text: 'Detractors', color: 'red', possible_values: [0, 1, 2, 3, 4, 5, 6] }
      ],
      2: [
        { text: 'Positives', color: 'green', possible_values: [1, 2, 3, 4, 5] },
        { text: 'Negatives', color: 'red', possible_values: [-5, -4, -3, -2, -1] }
      ]
    };

    return distributionMapping[noOfDistributions] || [];
  }


  //  Determines the highest level group name from the tags for a single touchpoint setup brand.
  getTouchpointName(defaultName: string, tags: any, brand: any): string {
    if (brand && brand.is_single_touchpoint_setup) {
      try {
        const levels = Object.keys(tags)
          .filter(tag => tag.startsWith('tag_private_group_h_') && tags[tag])
          .map(tag => ({
            value: Array.isArray(tags[tag]) ? tags[tag][0] : tags[tag],
            level: parseInt(tag.replace('tag_private_group_h_', '').replace('_', ''))
          }));

        const maxLevel = Math.max(...levels.map(lvl => lvl.level));
        const filteredLevels = levels.filter(lvl => lvl.level !== maxLevel);

        return filteredLevels.length > 0
          ? filteredLevels.reduce((max, lvl) => lvl.level > max.level ? lvl : max).value
          : defaultName;
      } catch (e) {
        return defaultName;
      }
    }
    return defaultName;
  }



  /*
    This method converts numeric values to string
    returns formated string like
    1200 - 1.2K
  */
  getNumericValueToFormatedString(number: any, roundedPosition: any) {
    if (roundedPosition == undefined) {
      roundedPosition = 1;
    }

    if (typeof (number) == "number") {
      if (number >= 1000 && number < 1000000) {
        number = number / 1000;
        number = this.getRoundOfPosition(number, roundedPosition);
        return number + 'K';
      } else if (number >= 1000000 && number < 1000000000) {
        number = number / 1000000;
        number = this.getRoundOfPosition(number, roundedPosition);
        return number + 'M';
      } else if (number >= 1000000000) {
        number = number / 1000000000;
        number = this.getRoundOfPosition(number, roundedPosition);
        return number + 'B';
      } else {
        return number
      }
    } else {
      return number;
    }
  }

  getRoundOfPosition(number: number, positions: any) {
    if (number && positions) {
      return parseFloat(number.toFixed(positions));
    } else {
      return number;
    }
  }


  /*
        *  This method gets the offset and name of the timezone.
        * @return: Returns name and offset of a brand
        */
  getBrandTimezoneDetails(brandDetails: any) {
    return new Promise((resolve, reject) => {
      if (brandDetails && brandDetails.default_time_zone) {
        try {
          const brandTimezone = brandDetails.default_time_zone.timezone || "UTC";
          const brandOffset = parseInt(brandDetails.default_time_zone.offset) || 0;
          resolve({ name: brandTimezone, offset: brandOffset });
        } catch (err) {
          console.error("Error occurred while getting brand timezone details:", err);
          reject(err);
        }
      } else {
        reject("Brand details or timezone information not available.");
      }
    });
  }

  /*this is will return time by offset */
  getTimeByOffset(offset, time, format) {
    if (format == false && format != undefined) {
      return moment.utc(time).utcOffset(-offset)
    }
    if (!format) {
      format = "DD-MMM-YY HH:mm:ss";
    }
    return moment.utc(time).utcOffset(-offset).format(format)
  }

  setDatePicker(dateObject: any) {
    // console.log("set date picker")
    let currentValue: any = this.datePickerSource.value;
    let appstate: any = this.appStateSource.value;
    this.helpers['datePicker'] = dateObject;
    appstate['datePicker'] = dateObject;
    currentValue = _.merge(currentValue, dateObject);
    this.datePickerSource.next(currentValue);
    // this.appStateSource.next(appstate);
    appstate['pending'] = false
    this.datePicker.next(this.datePickerSource.getValue())
    this.updateAppState(appstate, true)
    this.appStateService.updateCalendarData(dateObject)
  }

  setPendingState(isPanding: boolean, isReload?: boolean) {
    let appstate: any = this.appStateSource.value;
    if (isReload) {
      this.isReload = true;
    }

    if (isPanding) {
      appstate['pending'] = true;
    } else {
      appstate['pending'] = false;
    }
    this.appState.next(appstate)
  }

  getDatePickerValue() {
    return this.datePickerSource.value;
  }

  setHierarchyStack(hierarchyStack: any) {
    let appstate: any = this.appStateSource.value;
    this.helpers['hierarchyStack'] = hierarchyStack;
    appstate['hierarchyStack'] = hierarchyStack;
    // this.appStateSource.next(appstate);
    this.updateAppState(appstate, true);
    this.appStateService.updateHierarchyStack(hierarchyStack);
  }

  setUniversalFilters(fitlers: any) {
    let appstate: any = this.appStateSource.value;
    this.helpers['universalFilter'] = fitlers;
    appstate['universalFilter'] = fitlers;
    // this.appStateSource.next(appstate);
    this.updateAppState(appstate, true)
    this.appStateService.updateUniversalFilters(fitlers);
  }

  updateAccess(hierarchyStack?: any, fitlers?: any) {
    let updateState: boolean = false;
    let appstate: any = this.appStateSource.value;
    if (hierarchyStack && !_.isEmpty(hierarchyStack)) {
      this.helpers['hierarchyStack'] = hierarchyStack;
      appstate['hierarchyStack'] = hierarchyStack;
      updateState = true
    }
    if (fitlers) {
      this.helpers['universalFilter'] = fitlers;
      appstate['universalFilter'] = fitlers;
      updateState = true
    }

    if (updateState) {
      this.updateAppState(appstate, true)
      this.appStateService.updateAccess(hierarchyStack, fitlers);
    }

  }

  setHuddleFilter(filters: any) {
    let appstate: any = this.appStateSource.value;
    this.helpers['huddleFilters'] = filters;
    appstate['huddleFilters'] = filters;
    // this.appStateSource.next(appstate);
    this.updateAppState(appstate, true)
    this.appStateService.updateHuddleFilters(filters);
  }


  // Returns the value of a nested property in an object.
  getProp(obj: any, str: string): any {
    str = str.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    str = str.replace(/^\./, ''); // strip a leading dot
    const a = str.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (obj && typeof obj === 'object') {
        if (k in obj) {
          obj = obj[k];
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    }
    return obj;
  }



  // * @function: getPositiveNegativeColors: Get positive and negative colors
  // * @description: Return mini_rater_possitive_colors and mini_rater_negative_colors from present if present within brand,
  // *               else populate colors from the 'prop' within detailed_feedback_items where field_id is 'primary_rating'.
  // */
  getPositiveNegativeColors(brandDetail: any, questionArray: any[]): { positive: string[], negative: string[] } {
    const brand = brandDetail || this.helpers.brandDetail;
    if (!brand) return { positive: [], negative: [] };

    let positiveColors = brand.mini_rater_possitive_colors || [];
    let negativeColors = brand.mini_rater_negative_colors || [];

    // If no colors are set, use the colors from detailed feedback items
    if (positiveColors.length === 0 && negativeColors.length === 0 && brand.detailed_feedback_items?.length) {
      const primaryQuestion = brand.detailed_feedback_items.find(
        (item: any) => item.field_id === 'primary_rating'
      );

      if (primaryQuestion?.prop) {
        Object.entries(primaryQuestion.prop).forEach(([key, value]: [string, any]) => {
          const color = value.active_color;
          Number(key) > 0 ? positiveColors.push(color) : negativeColors.push(color);
        });
      }
    }

    // Filter positive colors if extended rater type is 4
    if (brand.extended_rater_type === 4 && positiveColors.length === 11) {
      positiveColors = positiveColors.filter((_color, index) => index % 2 === 1);
    }

    // Filter colors based on the question array
    if (questionArray?.length) {
      const primaryQuestion = questionArray.find(
        (question: any) => question.component_type === 'ltms-nps-five-star-rater' && question.field_id === 'primary_rating'
      );

      if (primaryQuestion && brand.extended_rater_type === 4 && positiveColors.length === 11) {
        positiveColors = positiveColors.filter((_color, index) => index % 2 === 1);
      }
    }

    return { positive: positiveColors, negative: negativeColors };
  }

  getCohortDataFromFieldDefinition() {
    var cohorFieldDefinitions: any = [];
    if (this.helpers && this.helpers.brandDetails && this.helpers.brandDetails.field_definitions) {
      var fieldDefinitions = this.helpers.brandDetails.field_definitions;
      fieldDefinitions.forEach(field => {
        if (field) {
          if ((field["es_filter"] || field["es_filter"] == "true") && (field["possible_value_search"] || field["possible_value_search"] == "true")) {
            if (field.field_id.includes("tag_")) {
              if (!field.field_id.includes("tag_private_")) {
                cohorFieldDefinitions.push(field)
              }
            }
          }
        }
      });
      return cohorFieldDefinitions;
    }
  }

  hasProperty(obj, keys) {
    return keys.split(".").every(function (key) {
      if (typeof obj != "object" || obj === null || !(key in obj)) {
        return false;
      }
      obj = obj[key];
      return true;
    });
  }

  getBrandDetails() {
    return this.helpers.brandDetails;
  }

  getHierarchyStack() {
    return this.helpers.hierarchyStack;
  }

  getDefaultLabelConfigs() {
    var defaultLabelConfigs = {
      "NPS": {
        "label": "NPS",
        "value": "",
        "default_value": "NPS",
        "placeholder": 'Enter new display name for "NPS" on the Dashboard',
        "seq": 1
      },
      "Score": {
        "label": "Score",
        "value": "",
        "default_value": "Score",
        "placeholder": 'Enter new display name for "Score" on the Dashboard',
        "seq": 1
      },
      "Average Rating": {
        "label": "Average Rating",
        "value": "",
        "default_value": "Average Rating",
        "placeholder": 'Enter new display name for "Average Rating" on the Dashboard',
        "seq": 1
      }
    }
    return defaultLabelConfigs;
  }

  setLabelConfigs(labelConfig) {
    var config = this.helpers.getDefaultLabelConfigs();
    if (!_.isEmpty(labelConfig)) {
      this.helpers.labelConfig = JSON.parse(JSON.stringify(labelConfig))
      for (var key in config) {
        if (_.isEmpty(labelConfig[key]) || (!_.isEmpty(labelConfig[key]) && (!labelConfig[key].value || labelConfig[key].value == ""))) {
          this.helpers.labelConfig[key] = {
            "value": config[key].default_value
          }
        }
      }
    } else {
      this.helpers.labelConfig = config;
    }
  }

  getDisplayLabel(name) {
    if (this.helpers.labelConfig && this.helpers.labelConfig[name] && this.helpers.labelConfig[name].value && this.helpers.labelConfig[name].value != "") {
      return this.helpers.labelConfig[name].value
    } else {
      return name
    }
  }

  getFieldDeviation(current, previous) {
    current = (!isNaN(current)) ? parseFloat(current) : current;
    previous = (!isNaN(previous)) ? parseFloat(previous) : previous;
    if (!previous || isNaN(previous)) {
      previous = 0;
    }
    if (!current || isNaN(current)) {
      current = 0;
    }
    if (!isNaN(current) && !isNaN(previous)) {
      var percentage = current - previous;
      if (percentage % 1) {
        percentage = parseFloat(percentage.toFixed(1));
      } else {
        percentage = parseInt(percentage.toFixed(0));
      }

      var deviation = {};
      if (percentage < 0) {
        deviation['arrowType'] = "down";
        percentage = -percentage;
      } else if (percentage > 0) {
        deviation['arrowType'] = "up";
      } else {
        deviation['arrowType'] = "no-change";
      }
      deviation['deviation'] = percentage === 0 ? '0' : this.helpers.getNumericValueToFormatedString(percentage, 1);
      deviation['difference'] = percentage;
      return deviation;
    } else {
      return null;
    }
  }

  getDeviationComparisonLabel(datePicker: any): string {
    if (!datePicker?.isPresetActive || datePicker?.isCustomDateRangeSelected) {
      return '';
    }

    const startDate = moment(datePicker.startDate, 'YYYYMMDD');
    const trendType = datePicker.trendType || this.getTrendTypeFromSelectedTrend(datePicker.selectedTrend);

    switch (trendType) {
      case 'day':
        return startDate.clone().subtract(1, 'day').format('DD MMM YYYY');
      case 'week':
        return 'Last week';
      case 'month':
        return startDate.clone().subtract(1, 'month').format('MMM YYYY');
      case 'quarter': {
        const prevQuarterStart = startDate.clone().subtract(1, 'quarter').startOf('quarter');
        const prevQuarterEnd = prevQuarterStart.clone().endOf('quarter');
        return `${prevQuarterStart.format('MMM')}-${prevQuarterEnd.format('MMM YYYY')}`;
      }
      case 'year':
        return startDate.clone().subtract(1, 'year').format('YYYY');
      case 'financial_year': {
        const fyStart = this.getFinancialYearStart(startDate);
        const prevFyStart = fyStart.clone().subtract(1, 'year');
        const prevFyEnd = prevFyStart.clone().add(1, 'year').quarter(1).endOf('quarter');
        return prevFyStart.format('YYYY');
      }
      default:
        return '';
    }
  }

  private getTrendTypeFromSelectedTrend(selectedTrend: number): string {
    switch (selectedTrend) {
      case 1: return 'day';
      case 2: return 'week';
      case 3: return 'month';
      case 4: return 'quarter';
      case 5: return 'year';
      default: return 'month';
    }
  }

  private getFinancialYearStart(startDate: moment.Moment): moment.Moment {
    if (startDate.quarter() > 1) {
      return startDate.clone().quarter(2).startOf('quarter');
    }
    return startDate.clone().subtract(1, 'years').quarter(2).startOf('quarter');
  }

  isReportDownloadEnabled() {

    let isReportDownloadAllowed = false;
    const brandDetails = this.helpers.deepClone(this.helpers.brandDetails);

    // Check if advanced download is enabled and get its visibility flag
    if (this.helpers.hasProperty(brandDetails, "module_configuration_v2.inbox.sub_modules.advanced_download.visible")) {
      isReportDownloadAllowed = Boolean(brandDetails.module_configuration_v2.inbox.sub_modules.advanced_download.visible);
    }

    // Disable if response download is explicitly disabled
    if (this.helpers.hasProperty(brandDetails, "is_response_download_disabled") && brandDetails.is_response_download_disabled === true) {
      isReportDownloadAllowed = false;
    }

    // If allowed at brand level, check at manager-level access download allowed or not
    return isReportDownloadAllowed ? this.isManagerDownloadEnabled() : false; // or `true` depending on logic

  }

  isManagerDownloadEnabled() {
    var manager = this.helpers.deepClone(this.helpers.managerDetails.loggedInManager);

    if (manager?.brand_id) {
      return !('report_download_allowed' in manager) ? true : manager.report_download_allowed;
    }

    return false;
  }


  getInitialQueryParameters() {

    var parameter = this.helpers.deepClone(this.helpers.managerDetails.loggedInManager);
    var brandDetails = this.helpers.deepClone(this.helpers.brandDetails);
    var initialQueryParams: any = {};

    if (!_.isEmpty(parameter)) {
      initialQueryParams = {
        "manager_type": parameter.manager_type,
        "brand_id": parameter.brand_id
      }
      if (parameter.manager_type == 1 && parameter.shop_id) {
        initialQueryParams.shop_id = this.helpers.touchpointId;
        initialQueryParams.main_rater_type = brandDetails.main_rater_type;
      } else if (parameter.manager_type == 7 && parameter.group_id) {
        initialQueryParams.group_id = parameter.group_id;
        initialQueryParams.main_rater_type = brandDetails.main_rater_type;
      } else if (parameter.manager_type == 2 && parameter.brand_id) {
        initialQueryParams.brand_id = parameter.brand_id;
        initialQueryParams.main_rater_type = brandDetails.main_rater_type;
      }

      if (this.helpers.touchpointId) {
        initialQueryParams.shop_id = this.helpers.touchpointId;
      } else if (this.helpers.groupId) {
        initialQueryParams.group_id = this.helpers.groupId;
      }

      if (!this.helpers.touchpointId) {
        initialQueryParams.shop_id_list = this.helpers.shopIdList;
      } else {
        initialQueryParams.shop_id_list = [];
      }

      if (this.helpers.hierarchyStack && this.helpers.hierarchyStack.length) {
        initialQueryParams.hierarchy_stack = this.helpers.hierarchyStack;
      }

      if (this.helpers.customFilterNextLevel && _.get(brandDetails, "is_single_touchpoint_setup")) {
        initialQueryParams.group_alias_key = this.helpers.customFilterNextLevel;
      }

      if (!initialQueryParams.group_alias_key) {
        initialQueryParams.group_alias_key = this.getGroupAliasKey()
      }

      if (this.helpers.customFilterList && this.helpers.customFilterList.length) {
        initialQueryParams.hierarchy_stack = [];
        this.helpers.customFilterList.forEach(function (filter) {
          initialQueryParams.hierarchy_stack.push({
            "field_id": filter.field,
            "group_key": [filter.value]
          })
        });
      }
    }
    return initialQueryParams;
  }

  private getGroupAliasKey(): any {
    let hierarchyStack = _.get(this.helpers, 'hierarchyStack', []) || [];
    hierarchyStack = hierarchyStack.filter(stack => stack?.field_id != 'touchpoints');
    if (hierarchyStack?.length) {
      const currentLevel = hierarchyStack[hierarchyStack.length - 1]?.field_id;
      if (currentLevel) {
        const hierarchyListAlias = _.get(this.helpers, 'brandDetails.hierarchy_list_alias', {});
        const alias = _.find(hierarchyListAlias, (item: any) => item?.values?.includes(currentLevel));
        if (alias) {
          const values = alias?.values;
          const nextLevelIndex = values.indexOf(currentLevel) + 1;
          return values[nextLevelIndex] || null;
        }
      }
    } else {
      const hierarchyFilterMapping = this.helpers?.hierarchyFilterMapping;
      return hierarchyFilterMapping[1]?.key;
    }
  }

  getNps(distribution, totalResponses) {
    if (distribution.promoters || distribution.detractors || totalResponses) {
      var promoters = (distribution.promoters / totalResponses) * 100;
      var detractors = (distribution.detractors / totalResponses) * 100;
      return Math.round(promoters - detractors);
    } else {
      return null;
    }
  }

  getColumnsWithDeviation(columns, records) {
    var deviationField = {};
    var isDeviationAvailable = false;
    _.each(columns, function (column) {
      if (column.is_deviation_enabled) {
        deviationField[column.field_name] = false;
      }
    });
    _.each(records, function (data) {
      _.each(deviationField, function (value, index) {
        if (data.deviations && data.deviations[index]) {
          deviationField[index] = true;
        }
      })
    });

    columns = columns.map(function (column) {
      if (column.is_deviation_enabled) {
        if (!(deviationField[column.field_name])) {
          column.is_deviation_enabled = false;
        } else {
          isDeviationAvailable = true;
        }
      }
      return column;
    });
    return {
      "columns": columns,
      "isDeviationAvailable": isDeviationAvailable
    };
  }

  getRandomString() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }


  getLoggedInAccessLevel = (cb) => {
    var accessLevel = {};
    try {
      const access: any = localStorage.getItem('QUERY_PARAM_OBJ')
      var loginInfo = JSON.parse(access);
      var managerType = _.get(loginInfo, "manager_type");

      var hierarchyListAlias = this.helpers.brandDetail.hierarchy_list_alias;

      // Fetch the latest hierarchy from the hierarchy_list_alias
      var latestHierarchyAlias: any = Object.values(hierarchyListAlias)[Object.values(hierarchyListAlias).length - 1];

      if (_.get(loginInfo, "access_key")) {
        //In case loginInfo contains 'access_key' i.e., Single Touchpoint
        accessLevel = loginInfo.access_key;
        cb(accessLevel);
      } else if (managerType == 2 || managerType == 1 || managerType == 3) {
        // In case type of manager is 2(Brand), 1(Touchpoint) or 3(account)

        // 2: Brand Manager: Top level Manager, 1: Touchpoint Manager: Bottom most level, 3: Account Manager(will have brand access i.e., top level access)

        // If manager type is 2 or 3 i.e., brand manager or account manager we'll consider it as they have top level access
        // when manager type is 1 then level will be the lowest level access.
        var level = (managerType == 2 || managerType == 3) ? latestHierarchyAlias["values"][0] : latestHierarchyAlias["values"][latestHierarchyAlias["values"].length - 1];
        accessLevel[level] = {};
        cb(accessLevel);
      }
    } catch (e) {
      cb(accessLevel);
    }
  }
  smallAlertBox(msgHeader: string, msgDetail: string, msgType: string, duration?: number) {
    this._toast.showPopup(msgType, msgHeader, msgDetail, duration)
  }

  getLoggedInAccessLevelAndValue() {
    var loginInfo: any = _.get(this.helpers, 'managerDetails.loggedInManager', {});
    let accessLevel: any = {};
    if (_.get(loginInfo, "access_key")) {
      accessLevel = loginInfo.access_key;
      var accessKey: any = Object.keys(accessLevel);
      // Considering, manager will have the access for single level at a time
      accessKey = accessKey[0];

      // Considering, manager will have access for one node for a level. Can't have access for multiple node for a level 
      var accessValue = _.get(accessLevel, accessKey + ".values.0");

      return ({ "level": accessKey, "value": accessValue });
    }
    return null;
  }

  finalTimeInMinForSLA(brandDetail, feedCreatedDate, v3StampParam) {

    var timezoneOffset = brandDetail.default_time_zone ? ((brandDetail.default_time_zone.offset ? brandDetail.default_time_zone.offset : -330)) : -330;
    var businessTimings = (brandDetail.conversation_config ? ((brandDetail.conversation_config.actions ? ((brandDetail.conversation_config.actions.business_timings ? (brandDetail.conversation_config.actions.business_timings) : undefined)) : undefined)) : undefined);

    if (businessTimings == undefined) {
      businessTimings = {};
    }


    var datetime2: any = v3StampParam ? new Date(v3StampParam) : new Date(brandDetail.timestamp_sla_brand)
    var datetime1: any = (new Date(feedCreatedDate));


    if (datetime2 == "Invalid Date" || datetime2.getFullYear() == 1970) {
      return "Error: TimeStamp Invalid";
    }

    var worktiming = businessTimings ? (businessTimings.worktiming ? (businessTimings.worktiming) : null) : null;
    var weekends = businessTimings ? (businessTimings.weekends ? (businessTimings.weekends) : []) : [];
    var holidays = businessTimings ? (businessTimings.holidays ? (businessTimings.holidays) : []) : [];
    var offset = timezoneOffset;

    if (holidays && holidays.length > 0) {
      for (let holidayNumber = 0; holidayNumber < holidays.length; holidayNumber++) {
        holidays[holidayNumber] = typeof holidays[holidayNumber].getMonth === 'function' ? holidays[holidayNumber] : (new Date(holidays[holidayNumber].substring(0, 10)));
      }
    }

    worktiming = worktiming ? worktiming : { "start": { "h": 0, "m": 0 }, "end": { "h": 23, "m": 59 } };
    offset = offset ? parseInt(offset) : -330;

    var dayHours = 24;
    var dayMinutes = 1440;
    var startTime = worktiming ? (worktiming.start ? (worktiming.start) : { "h": 0, "m": 0 }) : { "h": 0, "m": 0 };
    var endTime = worktiming ? (worktiming.end ? (worktiming.end) : { "h": 23, "m": 59 }) : { "h": 23, "m": 59 };

    var startHour = startTime ? (startTime.h ? (startTime.h) : 0) : 0;
    startHour = parseInt(startHour);
    var endHour = endTime ? (endTime.h ? (endTime.h) : 23) : 23;
    endHour = parseInt(endHour);
    var startMinute = startTime ? (startTime.m ? (startTime.m) : 0) : 0;
    startMinute = parseInt(startMinute);
    var endMinute = endTime ? (endTime.m ? (endTime.m) : (endTime.m == 0 ? 0 : 59)) : 59;
    endMinute = parseInt(endMinute);

    dayHours = (endHour - startHour);
    dayMinutes = dayHours * 60 + (endMinute - startMinute);


    var dateObj_1 = (new Date(datetime1));
    var dateObj_2 = (new Date(datetime2));

    var minutesWorkedfromtype2: any;
    var starthr = startHour + parseFloat((startMinute / 60).toFixed(2));
    var endhr = endHour + parseFloat((endMinute / 60).toFixed(2));
    minutesWorkedfromtype2 = this.slaWorkedSecondMethod(dateObj_1, dateObj_2, starthr, endhr, weekends, holidays);
    return minutesWorkedfromtype2;


  }

  getSlaClosureFinalDate(brandDetail, feedCreatedDate, v3StampParam) {
    var timezoneOffset: any = brandDetail.default_time_zone ? ((brandDetail.default_time_zone.offset ? brandDetail.default_time_zone.offset : -330)) : -330;
    var businessTimings: any = (brandDetail.conversation_config ? ((brandDetail.conversation_config.actions ? ((brandDetail.conversation_config.actions.business_timings ? (brandDetail.conversation_config.actions.business_timings) : undefined)) : undefined)) : undefined);

    if (businessTimings == undefined) {
      businessTimings = {};
    }


    var datetime2: any = v3StampParam ? new Date(v3StampParam) : new Date(brandDetail.timestamp_sla_brand)
    var datetime1: any = (new Date(feedCreatedDate));


    if (datetime2 == "Invalid Date" || datetime2.getFullYear() == 1970) {
      return "Error: TimeStamp Invalid";
    }

    var worktiming = businessTimings ? (businessTimings.worktiming ? (businessTimings.worktiming) : null) : null;
    var weekends = businessTimings ? (businessTimings.weekends ? (businessTimings.weekends) : []) : [];
    var holidays = businessTimings ? (businessTimings.holidays ? (businessTimings.holidays) : []) : [];
    var offset = timezoneOffset;

    if (holidays && holidays.length > 0) {
      for (let holidayNumber = 0; holidayNumber < holidays.length; holidayNumber++) {
        holidays[holidayNumber] = typeof holidays[holidayNumber].getMonth === 'function' ? holidays[holidayNumber] : (new Date(holidays[holidayNumber].substring(0, 10)));
      }
    }

    worktiming = worktiming ? worktiming : { "start": { "h": 0, "m": 0 }, "end": { "h": 23, "m": 59 } };
    offset = offset ? parseInt(offset) : -330;

    var dayHours = 24;
    var dayMinutes = 1440;
    var startTime = worktiming ? (worktiming.start ? (worktiming.start) : { "h": 0, "m": 0 }) : { "h": 0, "m": 0 };
    var endTime = worktiming ? (worktiming.end ? (worktiming.end) : { "h": 23, "m": 59 }) : { "h": 23, "m": 59 };

    var startHour = startTime ? (startTime.h ? (startTime.h) : 0) : 0;
    startHour = parseInt(startHour);
    var endHour = endTime ? (endTime.h ? (endTime.h) : 23) : 23;
    endHour = parseInt(endHour);
    var startMinute = startTime ? (startTime.m ? (startTime.m) : 0) : 0;
    startMinute = parseInt(startMinute);
    var endMinute = endTime ? (endTime.m ? (endTime.m) : (endTime.m == 0 ? 0 : 59)) : 59;
    endMinute = parseInt(endMinute);

    dayHours = (endHour - startHour);
    dayMinutes = dayHours * 60 + (endMinute - startMinute);


    var dateObj_1 = (new Date(datetime1));
    var dateObj_2 = (new Date(datetime2));

    var closureDate;
    var starthr = startHour + parseFloat((startMinute / 60).toFixed(2));
    var endhr = endHour + parseFloat((endMinute / 60).toFixed(2));

    var TATinhours = brandDetail ? (brandDetail.action_management_configuration ? (brandDetail.action_management_configuration.ageing_config ? (brandDetail.action_management_configuration.ageing_config.turnaround_time ? (brandDetail.action_management_configuration.ageing_config.turnaround_time) : null) : null) : null) : null;
    if (TATinhours != null) {
      closureDate = this.getClosureDateHelper(dateObj_1, TATinhours, starthr, endhr, weekends, holidays);
      return closureDate;
    } else {
      return "Error: No TAT Available"

    }

  }
  getClosureDateHelper(dateObj_1: any, TATinhours: any, starthr: any, endhr: any, weekends: any, holidays: any) {
    var timeSpentTillClosure: any = 0;
    var feedCreatedDummyDateObject: any = new Date(dateObj_1.getTime());
    var singleJSONForClosure: any = {};
    var startHourPure: any = parseInt(starthr);
    var startMinutePure: any = starthr - startHourPure;
    startMinutePure = startMinutePure * 60;
    var isCreatedOnHoliday: any = this.isWeekend(feedCreatedDummyDateObject, weekends, holidays);

    //Feed Created on a holiday
    if (isCreatedOnHoliday) {

      singleJSONForClosure.isFeedCreatedOnHoliday = true;
      //Looping to get the next Working Day
      while (isCreatedOnHoliday) {

        // next day
        feedCreatedDummyDateObject = new Date(feedCreatedDummyDateObject.setDate(feedCreatedDummyDateObject.getDate() + 1));
        isCreatedOnHoliday = this.isWeekend(feedCreatedDummyDateObject, weekends, holidays);
      }
    }
    //feedCreatedDummyDateObject is WORKING now

    // feed Created on a Working Day
    if (!singleJSONForClosure.isFeedCreatedOnHoliday) {
      //to check if the feedCreation done inside , before or after working hours
      var checkTimeIndicator = this.loggedInBeforeAfterWorkingHours(feedCreatedDummyDateObject, starthr, endhr)



      if (checkTimeIndicator == "loggedInBefore") {
        singleJSONForClosure.isFeedCreatedEarly = true;
        feedCreatedDummyDateObject = new Date(feedCreatedDummyDateObject.getFullYear(), feedCreatedDummyDateObject.getMonth(), feedCreatedDummyDateObject.getDate(), startHourPure, startMinutePure, 0);


      } else {
        if (checkTimeIndicator == "loggedInAfter") {
          singleJSONForClosure.isFeedCreatedLate = true;

          feedCreatedDummyDateObject = new Date(feedCreatedDummyDateObject.setDate(feedCreatedDummyDateObject.getDate() + 1));

          feedCreatedDummyDateObject = new Date(feedCreatedDummyDateObject.getFullYear(), feedCreatedDummyDateObject.getMonth(), feedCreatedDummyDateObject.getDate(), startHourPure, startMinutePure, 0);

        }
      }
    } else {
      feedCreatedDummyDateObject = new Date(feedCreatedDummyDateObject.getFullYear(), feedCreatedDummyDateObject.getMonth(), feedCreatedDummyDateObject.getDate(), startHourPure, startMinutePure, 0);
    }

    var dayCount: any = 0;
    var lastDayObject: any = new Date(feedCreatedDummyDateObject.getTime());
    while (timeSpentTillClosure < (TATinhours * 60)) {
      var isWeekendTruth = this.isWeekend(feedCreatedDummyDateObject, weekends, holidays);
      if (!isWeekendTruth) {
        dayCount++;
        if (dayCount == 1) {
          timeSpentTillClosure += (endhr * 60 - (feedCreatedDummyDateObject.getHours() * 60 + feedCreatedDummyDateObject.getMinutes()))
          lastDayObject = new Date(feedCreatedDummyDateObject.getTime())

        } else {
          if (!this.isWeekend(feedCreatedDummyDateObject, weekends, holidays)) {
            timeSpentTillClosure += (endhr - starthr) * 60
            lastDayObject = new Date(feedCreatedDummyDateObject.getTime())
          }
        }
      }
      // next day
      feedCreatedDummyDateObject = new Date(feedCreatedDummyDateObject.setDate(feedCreatedDummyDateObject.getDate() + 1));
    }

    var timeStampDueDate: any = parseFloat(((endhr * 60 - (timeSpentTillClosure - (TATinhours * 60))) / 60).toString()).toFixed(2);
    var hoursDueFinal: any = parseInt(timeStampDueDate);
    var minutesDueFinal: any = parseInt(((timeStampDueDate - parseInt(timeStampDueDate)) * 60).toString());

    // appending a zero in case the minutes value is single digit
    if (String(minutesDueFinal).length == 1) {
      minutesDueFinal = "0" + minutesDueFinal
    }

    var dateArrayForSla: any = lastDayObject.toDateString().split(" ");
    var dateStringSla: any = dateArrayForSla[0] + " " + dateArrayForSla[2] + "-" + dateArrayForSla[1] + "-" + dateArrayForSla[3].substring(2) + " " + hoursDueFinal + ":" + minutesDueFinal;
    return dateStringSla;
  }

  slaWorkedSecondMethod(dateObj_1, dateObj_2, starthr, endhr, weekends, holidays) {

    // If Start TIme is more then the end time
    if (dateObj_2.getTime() < dateObj_1.getTime()) {
      return 0;
    }

    var loggedInDateString: any = dateObj_2.toDateString();
    var feedCreatedDateString: any = dateObj_1.toDateString();
    var singleJSONObject: any = {};
    var minutesSpentOnFeed: any;

    // IF FEED CREATION done inside/outside working hours
    var feedCreatedInOutOfBounds: any = this.loggedInBeforeAfterWorkingHours(dateObj_1, starthr, endhr);

    if (feedCreatedInOutOfBounds == null) {
      singleJSONObject.isFeedCreatedInBounds = true;
    }
    else {
      singleJSONObject.isFeedCreatedInBounds = false;

      if (feedCreatedInOutOfBounds == "loggedInBefore") {
        singleJSONObject.isFeedCreatedEarly = true;
      }

    }

    // IF LOGIN DONE inside/outside working hours
    if (this.loggedInWorkingHours(dateObj_2, starthr, endhr)) {
      singleJSONObject.isLoggedInWorkingHours = true;
    } else {
      singleJSONObject.isLoggedInWorkingHours = false;
      var loggedInOutOfBounds = this.loggedInBeforeAfterWorkingHours(dateObj_2, starthr, endhr);
      if (loggedInOutOfBounds == "loggedInBefore") {
        singleJSONObject.isLoggedInEarly = true;
        singleJSONObject.isLoggedInLate = false;
      }

      if (loggedInOutOfBounds == "loggedInAfter") {
        singleJSONObject.isLoggedInEarly = false;
        singleJSONObject.isLoggedInLate = true;
      }
    }

    //IF LOGIN DATE is a HOLIDAY
    if (this.isWeekend(dateObj_2, weekends, holidays)) {
      singleJSONObject.isAWeekendOrHoliday = true;
    } else {
      singleJSONObject.isAWeekendOrHoliday = false;
    }

    //IF FEED CREATION DATE is a HOLIDAY
    if (this.isWeekend(dateObj_1, weekends, holidays)) {
      singleJSONObject.isFeedCreatedOnHoliday = true;
    } else {
      singleJSONObject.isFeedCreatedOnHoliday = false;
    }
    if (feedCreatedDateString == loggedInDateString) {  // Logging In SAME DAY As FEED CREATION
      //Single-day Setup

      if (singleJSONObject.isFeedCreatedOnHoliday) {
        return 0;
      } else if (singleJSONObject.isFeedCreatedInBounds) {
        if (singleJSONObject.isLoggedInWorkingHours) { // in working hours
          minutesSpentOnFeed = (dateObj_2.getTime() - dateObj_1.getTime()) / (1000 * 60);
        } else {  // late
          minutesSpentOnFeed = (endhr * 60) - (((dateObj_1.getHours()) * 60) + (dateObj_1.getMinutes()));
        }
      } else if (singleJSONObject.isFeedCreatedEarly) {
        if (singleJSONObject.isLoggedInEarly) {
          return 0;
        } else if (singleJSONObject.isLoggedInLate) {
          minutesSpentOnFeed = (endhr - starthr) * 60;
        } else {
          minutesSpentOnFeed = (dateObj_2.getHours() * 60) + (dateObj_2.getMinutes()) - (starthr * 60);
        }

      } else { //Feed Created AFTER ENDING Hours
        return 0;
      }

      if (minutesSpentOnFeed) {
        return parseFloat(minutesSpentOnFeed.toFixed(2));
      } else {
        return 0;
      }
    } else {  // Logging In Subsequent Days After Feed Creation   

      // Multi-day setup

      //Day1
      if (singleJSONObject.isFeedCreatedOnHoliday) {  // First Day OR Feed Created Day Was a Holiday
        minutesSpentOnFeed = 0;
      } else if (singleJSONObject.isFeedCreatedInBounds) { // FEED Created in working hours
        minutesSpentOnFeed = (endhr * 60) - (((dateObj_1.getHours()) * 60) + (dateObj_1.getMinutes()));
      } else if (singleJSONObject.isFeedCreatedEarly) { // Feed is Created Before Starting Hours
        minutesSpentOnFeed = (endhr - starthr) * 60;
      } else { //Feed Created AFTER ENDING Hours
        minutesSpentOnFeed = 0
      }

      //Middle Days
      var feedCreatedDummyObject = new Date(dateObj_1.getTime());
      var tempDateObject = new Date(feedCreatedDummyObject.setDate(feedCreatedDummyObject.getDate() + 1));// next day of feed Created Date
      var tempDateString = tempDateObject.toDateString();

      var fullDayCounter = 0;
      while (tempDateString != loggedInDateString) {
        if (!this.isWeekend(tempDateObject, weekends, holidays)) {
          fullDayCounter++;
        }
        tempDateObject = new Date(tempDateObject.setDate(tempDateObject.getDate() + 1)); // next day
        tempDateString = tempDateObject.toDateString();
      }
      minutesSpentOnFeed += fullDayCounter * (endhr - starthr) * 60;

      //LAST DAY
      if (!singleJSONObject.isAWeekendOrHoliday) {
        if (singleJSONObject.isLoggedInEarly) {
          minutesSpentOnFeed += 0;
        } else if (singleJSONObject.isLoggedInLate) {
          minutesSpentOnFeed += (endhr - starthr) * 60;
        } else {
          minutesSpentOnFeed += ((dateObj_2.getHours() * 60) + dateObj_2.getMinutes() - (starthr * 60))

        }

      }

      if (minutesSpentOnFeed) {
        return parseFloat(minutesSpentOnFeed.toFixed(2));
      } else {
        return 0;
      }
    }
  }

  getProperStringSLA(finalTimeInMin) {
    var finalTimeInMin: any = (Math.abs(finalTimeInMin));

    var seconds = Number(finalTimeInMin * 60);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);

    var dDisplay = d > 0 ? d + (d == 1 ? " D " : " D ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? " H " : " H ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " M " : " M, ") : "";
    return dDisplay + hDisplay + mDisplay;

  }

  loggedInBeforeAfterWorkingHours(loggedInDateTime, starthr, endhr) {
    var exactLoginTimeInHours = loggedInDateTime.getHours() + parseFloat((loggedInDateTime.getMinutes() / 60).toFixed(2));
    if (exactLoginTimeInHours < starthr) {
      return "loggedInBefore";
    }

    if (exactLoginTimeInHours > endhr) {
      return "loggedInAfter"
    }

    return null;
  }
  isWeekend(datetime1obj, weekends, holidays) {
    var dateNumber = datetime1obj.getDay();
    dateNumber = (dateNumber == 0) ? 7 : dateNumber;
    var isHolidayTruth = this.isHoliday(datetime1obj, holidays);

    if (isHolidayTruth) {
      return true;
    }

    for (var weekendNumber = 0; weekendNumber < weekends[weekendNumber]; weekendNumber++) {
      if (weekends[weekendNumber] == dateNumber) {
        return (true || isHolidayTruth);
      }
    }
    return (false && isHolidayTruth);
  }


  isHoliday(datetime1obj, holidays) {
    // should return true if the current date falls in one of the holidays
    var date1 = datetime1obj.toDateString();
    for (let holidayNumberCheck = 0; holidayNumberCheck < holidays.length; holidayNumberCheck++) {
      let holidayDate = holidays[holidayNumberCheck].toDateString()
      if (holidayDate == date1) {
        return true;
      }
    }
    return false;
  }
  loggedInWorkingHours(loggedInDateTime, starthr, endhr) {
    var exactLoginTimeInHours = loggedInDateTime.getHours() + parseFloat((loggedInDateTime.getMinutes() / 60).toFixed(2));
    if (exactLoginTimeInHours >= starthr && exactLoginTimeInHours <= endhr) {
      return true;
    }
    else {
      return false;
    }
  }
  removeSpecialCharacters(string, replacement_string, include_space) {
    // remove special character
    string = string.replace(/[^a-zA-Z0-9]/g, replacement_string);
    var regx = new RegExp(replacement_string + '{2,}', 'g');
    if (include_space) {
      // remove blank spaces 
      string = string.replace(/ /g, replacement_string);
    }
    string = string.replace(regx, replacement_string);
    regx = new RegExp(replacement_string + '{1,}$', 'g');
    string = string.replace(regx, replacement_string);
    return string.toLowerCase();
  }

  checkAccessByFeature(feature, accessList, issueDetail, brandDetail) {
    var isAccountMgr = false;
    var isBrandMgr = false;
    var isStoreMgr = false;
    var isGroupMgr = false;
    var allowedForBrand = false;
    var allowedForShop = false;
    var allowedForGroup = false;
    var store = issueDetail.shops[0] || {};
    var groups = store.groups || [];
    var feed = issueDetail.feed;

    if (accessList && accessList.length) {
      _.each(accessList, function (acs) {
        if (acs.has_dashboard_access) {
          if ((acs.brand_id && acs.brand_id.toString() == feed.brand_id.toString()) && acs.manager_type == 2) {
            isBrandMgr = true;
            allowedForBrand = feature in acs ? acs[feature] : true;
          } else if ((acs.account_id && (acs.account_id.toString() == brandDetail.account_id.toString())) && acs.manager_type == 3) {
            isAccountMgr = true;
          } else if (((acs.shop_id && (acs.shop_id.toString() == feed.feed_target_id.toString()))) && acs.manager_type == 1) {
            isStoreMgr = true;
            allowedForShop = feature in acs ? acs[feature] : true;
          } else if ((acs.group_id && (groups && groups.length && groups.indexOf(acs.group_id) >= 0)) && acs.manager_type == 7) {
            isGroupMgr = true;
            allowedForGroup = feature in acs ? acs[feature] : true;
          }
        }
      })
    }

    if (isAccountMgr) {
      return true;
    } else if (isBrandMgr) {
      return allowedForBrand;
    } else if (isGroupMgr) {
      return allowedForGroup;
    } else if (isStoreMgr) {
      return allowedForShop;
    } else {
      return false;
    }
  }
  getUniversalFilter() {
    var filters: any = {};
    if (this.helpers.universalFilter && !_.isEmpty(this.helpers.universalFilter)) {
      if (this.helpers.universalFilter.text_filter && !_.isEmpty(this.helpers.universalFilter.text_filter)) {
        filters = JSON.parse(JSON.stringify(this.helpers.universalFilter))
        filters.text_filter = JSON.stringify(filters.text_filter)
      } else {
        filters = JSON.parse(JSON.stringify(this.helpers.universalFilter))
      }
      if (filters.question_filter) {
        var groupIds: any = [];
        _.each(filters.question_filter, function (filter) {
          if (filter.group_id && groupIds.indexOf(filter.group_id) == -1) {
            groupIds.push(filter.group_id)
          }
        })
        if (groupIds && groupIds.length) {
          for (var idx in groupIds) {
            var question = _.get(filters, 'question_filter.' + groupIds[idx]);
            if (question && question.is_all_selected != true && question.action == 'ne') {
              filters.question_filter[groupIds[idx]].action = 'eq';
            }
          }
        }
      }
    }

    return (!_.isEmpty(filters)) ? filters : null;
  }

  setUniversalFilter(filterType: string, question_id: string, data: any) {
    let filtersMap = this.globalFilterService.getGolbalFilters();
    let universalFilter = this.globalFilterService.getUniveralFilters();
    let appliedFilters: any = []
    if (_.isEmpty(universalFilter)) {
      universalFilter = {
        isAppliedFromAccount: this.helpers['isAccount'],
        filters: []
      }
    }
    if (_.isEmpty(filtersMap)) {
      filtersMap = {}
    }

    switch (filterType) {
      case "text_filter":
        appliedFilters = this.setTextFilter(filtersMap, universalFilter, question_id, data.value);
        break;
      case "tag_filter":
        appliedFilters = this.setTagFilter(universalFilter, data);
        break;
      case "question_filter":
        appliedFilters = this.setQuestionFilter(universalFilter, data);
        break;
      default:
        break;
    }
    const multiSelectFilters = this.globalFilterService.getMultiSelectQuestionFilter(appliedFilters.filters);
    let formatedFilters = this.globalFilterService.getFormatedUniversalFilter(appliedFilters.filters);
    if (multiSelectFilters && !_.isEmpty(multiSelectFilters)) {
      Object.assign(formatedFilters.question_filter, multiSelectFilters);
    }
    formatedFilters = this.globalFilterService.excludeMultiSelectFilter(formatedFilters);
    this.globalFilterService.storeUniversalFilters(appliedFilters);
    this.setUniversalFilters(formatedFilters);

  }

  setTagFilter(universalFilter: any, data: any): any {
    if (data === 'reset') {
      universalFilter.filters = universalFilter?.filters.filter(item => {
        return !(item.appliedFrom === 'rhs_cohorts');
      })
      return universalFilter;
    }
    if (universalFilter?.filters && universalFilter?.filters.length > 0) {
      let tagName = data?.tag_name;
      if (data?.child && data?.child.length > 0) {
        let extractFieldIds = data?.child.map(item => item.field_id);
        let keyIndex = extractFieldIds.indexOf(tagName);
        universalFilter.filters = universalFilter?.filters.filter(item => {
          return !(item.appliedFrom === 'rhs_cohorts' && extractFieldIds.indexOf(item.fieldId) > keyIndex);
        });
      }
    }
    universalFilter?.filters.push(
      {
        "filterType": "transaction_filter",
        "fieldId": data?.tag_name,
        "fieldText": data?.value,
        "operator": "eq",
        "isMultiSelect": false,
        "operatorText": "Equal To",
        "valueText": data?.value,
        "values": [data?.values],
        "labels": data?.value,
        "details": [
          {
            "text": data?.value,
            "value": data?.value
          }
        ],
        "possibleValues": data?.value,
        "filterText": "Metadata",
        "appliedFrom": "rhs_cohorts"
      }
    )
    return universalFilter;
  }

  setQuestionFilter(universalFilter: any, data: any): any {
    if (data === 'reset') {
      universalFilter.filters = universalFilter?.filters.filter(item => {
        return !(item.appliedFrom === 'rhs_cohorts');
      })
      return universalFilter;
    }
    if (universalFilter?.filters && universalFilter?.filters.length > 0) {
      let tagName = data?.tag_name;
      if (data?.child && data?.child.length > 0) {
        let extractFieldIds = data?.child.map(item => item.field_id);
        let keyIndex = extractFieldIds.indexOf(tagName);
        universalFilter.filters = universalFilter?.filters.filter(item => {
          return !(item.appliedFrom === 'rhs_cohorts' && extractFieldIds.indexOf(item.fieldId) > keyIndex);
        });
      }
    }
    universalFilter?.filters.push(
      {
        "filterType": "question_filter",
        "fieldId": data?.tag_name,
        "fieldText": data?.value,
        "operator": "eq",
        "isMultiSelect": false,
        "operatorText": "Equal To",
        "valueText": data?.value,
        "values": [Number(data?.values)],
        "labels": data?.value,
        "details": [
          {
            "text": data?.value,
            "value": data?.value
          }
        ],
        "possibleValues": data?.value,
        "filterText": "Metadata",
        "appliedFrom": "rhs_cohorts"
      }
    )
    return universalFilter;
  }

  setTextFilter(filtersMap: any, appliedFilters: any, question_id: string, value: string) {
    const index = _.findIndex(appliedFilters.filters, { filterType: "text_filter", operator: "contains", fieldId: question_id });
    const textFilters = _.get(filtersMap, 'textFilter.filters', [])
    const question = _.find(textFilters, { "field_id": question_id });
    if (!_.isEmpty(question)) {
      if (index < 0) {
        appliedFilters.filters.push({
          "filterType": "text_filter",
          "fieldId": question_id,
          "fieldText": question.question,
          "operator": "contains",
          "isMultiSelect": false,
          "operatorText": "Contains",
          "valueText": value,
          "values": [value],
          "labels": [],
          "details": [],
          "filters": _.values(filtersMap),
          "filterText": "Text-Based"
        })
      } else if (index >= 0) {
        appliedFilters.filters[index].values.push(value);
        appliedFilters.filters[index].valueText = appliedFilters.filters[index].values.join(",")
      }
    }
    return appliedFilters
  }

  resetAppState(caller?: string) {
    // console.log("Reset App State, caller is....", caller)
    let appstate: any = this.appStateSource.value;
    if (caller == 'account' || caller == 'full_reset') {
      delete this.helpers['brandDetails'];
      delete this.helpers['hierarchyMapping'];
      delete this.helpers['hierarchyFilterMapping'];
      delete this.helpers['hierarchyStack'];
      delete this.helpers['universalFilter'];
      delete this.helpers['datePicker'];
      delete this.helpers['projectType'];
      delete this.helpers['accountAdminRules'];
      delete this.helpers['accountAdminRulesDic'];
      delete this.helpers['accountModuleConfigs'];

      delete appstate['brandDetails'];
      delete appstate['hierarchyMapping'];
      delete appstate['hierarchyFilterMapping'];
      delete appstate['universalFilter'];
      delete appstate['hierarchyStack'];
      delete appstate['datePicker'];
      delete appstate['projectType'];

      this.globalFilterService.resetFilters(true, true);
    }

    if (caller == 'full_reset') {
      delete this.helpers['accountDetails'];
      delete this.helpers['accessObject'];
      delete this.helpers['managerAccess'];
      delete this.helpers['brandListDetail'];
      delete this.helpers['isAccount'];
      delete this.helpers['managerDetails'];
      delete this.helpers['projectAdminRules'];
      delete this.helpers['projectAdminRulesDic'];
      delete this.helpers['projectModuleConfigs'];
      delete this.helpers['accountAdminRules'];
      delete this.helpers['accountAdminRulesDic'];
      delete this.helpers['accountModuleConfigs'];

      delete appstate['isAccount'];
      delete appstate['managerDetails'];
      delete appstate['accountDetails'];
      delete appstate['brandListDetail'];
      delete appstate['accessObject'];
      delete appstate['managerAccess'];
    }

    if (caller == 'project') {
      delete appstate['hierarchyMapping'];
      delete appstate['hierarchyFilterMapping'];
      delete appstate['universalFilter'];
      delete appstate['hierarchyStack'];

      delete this.helpers['hierarchyMapping'];
      delete this.helpers['hierarchyFilterMapping'];
      delete this.helpers['hierarchyStack'];
      delete this.helpers['universalFilter'];
      delete this.helpers['projectAdminRules'];
      delete this.helpers['projectAdminRulesDic'];
      delete this.helpers['projectModuleConfigs'];

      this.globalFilterService.resetFilters(true, true);

    }

    window['Helpers'] = this.consoleData();
    this.appStateSource.next(appstate);
  }

  resetUniversalFilter(isAccount: boolean) {
    const universalFilter = this.globalFilterService.getUniveralFilters();
    let globalFilterData = this.globalFilterService.getAppliedFilters();
    let appstate: any = this.appStateSource.value;
    let cleareFilterRequired: boolean = false
    let isUniversalFilterReset: boolean = false;
    let isHierarchFilterReset: boolean = false;
    let resetType: string = '';
    if (universalFilter && universalFilter.filters && universalFilter.filters.length && universalFilter.isAppliedFromAccount != isAccount) {
      delete this.helpers['universalFilter'];
      delete appstate['universalFilter'];
      delete this.helpers['hierarchyStack'];
      delete appstate['hierarchyStack'];
      isUniversalFilterReset = true
      cleareFilterRequired = true
      resetType = 'universalfilter##hierarchystack';
    }
    if (isAccount && ((globalFilterData && globalFilterData['by_hierarchy_drilldown']) || (globalFilterData && globalFilterData['by_hierarchy_level_and_value']))) {
      delete this.helpers['hierarchyStack'];
      delete appstate['hierarchyStack'];
      cleareFilterRequired = true;
      isHierarchFilterReset = true;
      resetType += '##hierarchystack';
    }
    this.appStateService.resetFilters(resetType);
    if (cleareFilterRequired) {
      this.globalFilterService.resetFilters(isUniversalFilterReset, isHierarchFilterReset);
      window['Helpers'] = this.consoleData();
      this.appStateSource.next(appstate);
      this.appStateService.resetAppstate('reset_universal_filter', isUniversalFilterReset, isHierarchFilterReset);
    }

    // this.globalFilterService.resetFilters();
  }

  prepareRouteData(urlstr: string) {
    let url = urlstr.split('?')[0];
    let paramStr = urlstr.split('?')[1];
    let routeData: any = {}
    if (url != '') {
      const urlarr = url.split('/');
      routeData.url = urlstr
      if (urlarr[2] == 'project') {
        routeData.level = 'project'
        routeData.routeName = urlarr[3]
        if (urlarr.length >= 5) {
          routeData.subRouteName = urlarr[4];
        }
      } else {
        routeData.level = 'account'
        routeData.routeName = urlarr[2]
        if (urlarr.length >= 4) {
          routeData.subRouteName = urlarr[3];
        }
      }





    }
    if (paramStr && paramStr != '') {
      let paramarray = paramStr.split("&")
      _.each(paramarray, (qyerystr: string) => {
        const arr = qyerystr.split("=")
        routeData[arr[0]] = arr[1]
      })
    }
    return routeData;
  }
  showConfirmationBox(title: string, content: string, cb: any) {
    this.messageBox.next({
      "title": title,
      "content": content,
      "buttons": [{
        text: "No",
        type: 'secondary',
        key: 'No'
      }, {
        text: "Yes",
        type: 'primary',
        key: 'Yes'
      }],
      cb: (ButtonPressed) => {
        if (ButtonPressed === "Yes") {
          cb(true);
        } else {
          cb(false);
        }
      }
    })

  }

  smartMessageBox(detail: any, cb: any) {
    let buttons: any = [{
      text: "No",
      type: 'secondary',
      key: 'No'
    }, {
      text: "Yes",
      type: 'primary',
      key: 'Yes'
    }]
    if (detail.buttons) {
      buttons = detail.buttons;
    }
    this.messageBox.next({
      "title": detail.title,
      "content": detail.content,
      "buttons": buttons,
      cb: (ButtonPressed) => {
        cb(ButtonPressed)
      }
    })

  }

  getRaterDetails(raterType?: string) {
    var raters = {
      "1": {
        "name": "litmus",
        "min_score": -5,
        "max_score": 5,
        "distributions": [{
          "value": 2,
          "label": "Positives",
          "color": "#0b7139",
          "field_id": "positives"
        }, {
          "value": 1,
          "label": "Negatives",
          "color": "#ed2424",
          "field_id": "negatives"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#f5ea14"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#bbd531"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#66b846"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#0b7139"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#06521f"
          },
          "-5": {
            "value": -5,
            "label": "#-5",
            "active_color": "#c42031"
          },
          "-4": {
            "value": -4,
            "label": "#-4",
            "active_color": "#ed2424"
          },
          "-3": {
            "value": -3,
            "label": "#-3",
            "active_color": "#f05f22"
          },
          "-2": {
            "value": -2,
            "label": "#-2",
            "active_color": "#f48020"
          },
          "-1": {
            "value": -1,
            "label": "#-1",
            "active_color": "#fab416"
          }
        },
        "average_rating_range": [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
        "average_rating_labels": [-5, -3, -1, 1, 3, 5],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
      },
      "2": {
        "name": "others",
        "min_score": 0,
        "max_score": 0,
        "distributions": [],
        "prop": {},
        "average_rating_range": [],
        "average_rating_labels": [],
        "percentage_labels": [],
        "number_of_ticks": 0
      },
      "3": {
        "name": "nps",
        "min_score": -100,
        "max_score": 100,
        "distributions": [{
          "value": 3,
          "label": "Promoters",
          "color": "#008000",
          "field_id": "promoters"
        }, {
          "value": 2,
          "label": "Passives",
          "color": "#ffa500",
          "field_id": "passives"
        }, {
          "value": 1,
          "label": "Detractors",
          "color": "#ff0000",
          "field_id": "detractors"
        }],
        "prop": {
          "0": {
            "value": 0,
            "label": "#0",
            "active_color": "#ed2424"
          },
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#ed2424"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#ed2424"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#ed2424"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#ed2424"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#ed2424"
          },
          "6": {
            "value": 6,
            "label": "#6",
            "active_color": "#ed2424"
          },
          "7": {
            "value": 7,
            "label": "#7",
            "active_color": "#fab416"
          },
          "8": {
            "value": 8,
            "label": "#8",
            "active_color": "#fab416"
          },
          "9": {
            "value": 9,
            "label": "#9",
            "active_color": "#0b7139"
          },
          "10": {
            "value": 10,
            "label": "#10",
            "active_color": "#0b7139"
          }
        },
        "average_rating_range": [-100, -80, -60, -40, -20, 0, 20, 40, 60, 80, 100],
        "average_rating_labels": [-100, -60, -20, 20, 60, 100],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
      },
      "4": {
        "name": "1to5",
        "min_score": 0,
        "max_score": 5,
        "distributions": [{
          "value": 3,
          "label": "T2B",
          "color": "#10a754",
          "field_id": "top"
        }, {
          "value": 2,
          "label": "MB",
          "color": "#fab416",
          "field_id": "mid"
        }, {
          "value": 1,
          "label": "B2B",
          "color": "#ed2424",
          "field_id": "bottom"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#c62828"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#e53935"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#f5ea14"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#66b846"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#1b5e20"
          }
        },
        "average_rating_range": [1, 2, 3, 4, 5],
        "average_rating_labels": [0, 1, 2, 3, 4, 5],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
      },
      "6": {
        "name": "1to10",
        "min_score": 0,
        "max_score": 10,
        "distributions": [{
          "value": 3,
          "label": "T3B",
          "color": "#10a754",
          "field_id": "top"
        }, {
          "value": 2,
          "label": "MB",
          "color": "#fab416",
          "field_id": "mid"
        }, {
          "value": 1,
          "label": "B3B",
          "color": "#ed2424",
          "field_id": "bottom"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#b71c1c"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#c62828"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#d32f2f"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#e53935"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#f44336"
          },
          "6": {
            "value": 6,
            "label": "#6",
            "active_color": "#f5ea14"
          },
          "7": {
            "value": 7,
            "label": "#7",
            "active_color": "#bbd531"
          },
          "8": {
            "value": 8,
            "label": "#8",
            "active_color": "#66b846"
          },
          "9": {
            "value": 9,
            "label": "#9",
            "active_color": "#06521f"
          },
          "10": {
            "value": 10,
            "label": "#10",
            "active_color": "#1b5e20"
          }
        },
        "average_rating_range": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        "average_rating_labels": [0, 2, 4, 6, 8, 10],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
      },
      "7": {
        "name": "1to6",
        "min_score": 0,
        "max_score": 6,
        "distributions": [{
          "value": 3,
          "label": "T2B",
          "color": "#10a754",
          "field_id": "top"
        }, {
          "value": 2,
          "label": "MB",
          "color": "#fab416",
          "field_id": "mid"
        }, {
          "value": 1,
          "label": "B2B",
          "color": "#ed2424",
          "field_id": "bottom"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#b71c1c"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#d32f2f"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#f44336"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#f5ea14"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#66b846"
          },
          "6": {
            "value": 6,
            "label": "#6",
            "active_color": "#1b5e20"
          }
        },
        "average_rating_range": [1, 2, 3, 4, 5, 6],
        "average_rating_labels": [0, 2, 4, 6],
        "percentage_labels": [0, 33, 67, 100],
        "number_of_ticks": 4
      },
      "8": {
        "name": "-3to+3",
        "min_score": -3,
        "max_score": 3,
        "distributions": [{
          "value": 2,
          "label": "Positives",
          "color": "#0b7139",
          "field_id": "positives"
        }, {
          "value": 1,
          "label": "Negatives",
          "color": "#ed2424",
          "field_id": "negatives"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#f5ea14"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#66b846"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#1b5e20"
          },
          "-3": {
            "value": -3,
            "label": "#-3",
            "active_color": "#b71c1c"
          },
          "-2": {
            "value": -2,
            "label": "#-2",
            "active_color": "#d32f2f"
          },
          "-1": {
            "value": -1,
            "label": "#-1",
            "active_color": "#f44336"
          }
        },
        "average_rating_range": [-3, -2, -1, 0, 1, 2, 3],
        "average_rating_labels": [-3, -1, 1, 3],
        "percentage_labels": [0, 33, 67, 100],
        "number_of_ticks": 4
      },
      "9": {
        "name": "1to4",
        "min_score": 0,
        "max_score": 4,
        "distributions": [{
          "value": 3,
          "label": "TB",
          "color": "#10a754",
          "field_id": "top"
        }, {
          "value": 2,
          "label": "MB",
          "color": "#fab416",
          "field_id": "mid"

        }, {
          "value": 1,
          "label": "BB",
          "color": "#ed2424",
          "field_id": "bottom"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#b71c1c"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#e53935"
          },
          "3": {
            "value": 4,
            "label": "#4",
            "active_color": "#bbd531"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#1b5e20"
          }
        },
        "average_rating_range": [1, 2, 3, 4],
        "average_rating_labels": [0, 1, 2, 3, 4],
        "percentage_labels": [0, 25, 50, 75, 100],
        "number_of_ticks": 5
      }
    };
    if (raterType && raterType in raters) {
      return JSON.parse(JSON.stringify(raters[raterType]));
    } else if (raterType) {
      return {};
    } else {
      return JSON.parse(JSON.stringify(raters));
    }
  }
  /**
   * Description: this function format the nested module config and seprate in main menu  or sub menu
   * @param moduleConfig 
   * @param isAccount 
   * @returns 
   */
  getFlatenModuleConfig(moduleConfig: any, isAccount: boolean) {
    let mainMenu: any = {};
    let subMenu: any = {};
    const tabs = (isAccount) ? environment.account_tabs : environment.project_tabs;
    const tabMappings: any = environment.tab_mappings;
    const selectedMapping = (isAccount == true) ? tabMappings['account'] : tabMappings['project'];
    const firstTabConfigs = (isAccount == true) ? FirstTabConfigs['account'] : FirstTabConfigs['project'];

    let moduleConfigV2 = _.merge(this.helpers.deepClone(moduleConfig), tabs);
    if (isAccount != true) {
      moduleConfigV2['sent_beta'] = _.get(moduleConfigV2, 'inbox.sub_modules.sent_beta', { visible: false })
    }
    _.each(moduleConfigV2, (module: any, moduleKey: string) => {
      if (_.hasIn(module, 'visible')) {
        if (moduleKey == 'inbox') {
          module.sub_modules['verbatim'] = _.get(moduleConfigV2, 'scores.sub_modules.verbatim', { "visible": false })
        }
        let firstTab: string = '';
        const tabMap = (moduleKey && selectedMapping[moduleKey]) ? selectedMapping[moduleKey] : null;
        if (tabMap && tabMap.length && module.sub_modules && !_.isEmpty(module.sub_modules)) {

          let isVisible: boolean = false;
          _.each(tabMap, (subModulekey: string) => {
            if (subModulekey && _.has(module.sub_modules, subModulekey + '.visible') && _.get(module.sub_modules, subModulekey + '.visible') == true) {
              isVisible = true;
            } else if (subModulekey == 'wordcloud') {
              isVisible = true;
            }
            if (subModulekey && _.hasIn(module.sub_modules, subModulekey + '.visible')) {
              if (!_.hasIn(subMenu, moduleKey)) {
                subMenu[moduleKey] = {}
              }
              subMenu[moduleKey][subModulekey] = _.get(module.sub_modules, subModulekey, { "visible": false })
            }
            if (firstTab == '' && subModulekey && _.has(module.sub_modules, subModulekey + '.visible') && _.get(module.sub_modules, subModulekey + '.visible') == true && _.has(module.sub_modules, subModulekey + '.enabled') && _.get(module.sub_modules, subModulekey + '.enabled') == true) {
              firstTab = subModulekey;
            }
          })

          if (module.visible) {
            module.visible = isVisible;
          }
          if (isVisible && firstTab != '' && _.has(firstTabConfigs, moduleKey + "." + firstTab) && firstTabConfigs[moduleKey][firstTab] != '') {
            module.firstTab = firstTabConfigs[moduleKey][firstTab];
          }
        }

        mainMenu[moduleKey] = module;
      }
    })
    if (isAccount) {
      this.moduleConfig.account = {
        mainMenu: mainMenu,
        subMenu: subMenu
      }
    } else {
      this.moduleConfig.project = {
        mainMenu: mainMenu,
        subMenu: subMenu
      }
    }
    return this.moduleConfig;
  }

  /**
   * Description: function is used to check module or sub module visiblity
   * @param isAccount 
   * @param moduleName 
   * @param subModuleName 
   * @returns 
   */
  isTabVisible(isAccount: boolean, moduleName: string, subModuleName?: string) {
    const subModuleMap = {
      'customer_feedback': 'received',
      'all_responses': 'received',
    }
    if (!_.isEmpty(this.moduleConfig)) {
      if (moduleName && moduleName != '') {
        const level = (isAccount) ? 'account' : 'project';
        const module = _.get(this.moduleConfig, level + '.mainMenu.' + moduleName)
        if (subModuleName && subModuleName != '') {
          const subModulekey = (subModuleMap[subModuleName]) ? subModuleMap[subModuleName] : subModuleName;
          const subModule = _.get(this.moduleConfig, level + '.subMenu.' + moduleName + '.' + subModulekey);
          if (subModule && subModule.visible && subModule.enabled) {
            return true;
          } else {
            return false;
          }
        } else {
          if (module && module.visible && module.enabled) {
            return true
          } else {
            return false
          }
        }

      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isValidJSON(object: any) {
    try {
      if (typeof object == 'string') {
        if ((object.startsWith('{') && object.endsWith('}')) || (object.startsWith('[') && object.endsWith(']'))) {
          JSON.parse(object)
          return true;
        } else {
          return false;
        }
      } else if (typeof object == 'object') {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  INRCurrencyPipeFilter(value) {
    if (value == 0 || value < 0) {
      return value;
    } else {
      let x: any = value;
      x = x.toString();
      var afterPoint = '';
      if (x.indexOf('.') > 0)
        afterPoint = x.substring(x.indexOf('.'), x.length);
      x = Math.floor(x);
      x = x.toString();
      var lastThree = x.substring(x.length - 3);
      var otherNumbers = x.substring(0, x.length - 3);
      if (otherNumbers != '')
        lastThree = ',' + lastThree;
      var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
      return res;
    }
  }

  // Call this method to compare previous stored hierarchy stack and new hierarchy stack, based on comparison call the APIs
  generateHashForHierarchyStack(arr) {
    if (arr !== undefined) {
      return arr.map(obj => `${obj.field_id}-${obj.group_key}`).join('|'); // Simple hash function
    } else {
      return 'NOHASHED'
    }
  }

  statusMap: any = {
    "1": "Setup",
    "2": "Live",
    "3": "Closed",
    "4": "Archive",
    "5": "Design",
    "6": "On Hold"
  };

  generateColor(colorStart, colorEnd, colorCount) {
    // The beginning of your gradient
    var start = this.convertToRGB(colorStart);

    // The end of your gradient
    var end = this.convertToRGB(colorEnd);

    // The number of colors to compute
    var len = colorCount;

    //Alpha blending amount
    var alpha = 0.0;

    var colors: any = [];

    for (let i = 0; i < len; i++) {
      var c: any = [];
      alpha += (1.0 / len);

      c[0] = start[0] * alpha + (1 - alpha) * end[0];
      c[1] = start[1] * alpha + (1 - alpha) * end[1];
      c[2] = start[2] * alpha + (1 - alpha) * end[2];
      const color = this.convertToHex(c)
      colors.push(color);

    }

    return colors;

  }
  hex(c) {
    var s = "0123456789abcdef";
    var i = parseInt(c);
    if (i == 0 || isNaN(c))
      return "00";
    i = Math.round(Math.min(Math.max(0, i), 255));
    return s.charAt((i - i % 16) / 16) + s.charAt(i % 16);
  }

  /* Convert an RGB triplet to a hex string */
  convertToHex(rgb) {
    return this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]);
  }

  /* Remove '#' in color hex string */
  trim(s) {
    return (s.charAt(0) == '#') ? s.substring(1, 7) : s
  }

  /* Convert a hex string to an RGB triplet */
  convertToRGB(hex) {
    var color: any = [];
    color[0] = parseInt((this.trim(hex)).substring(0, 2), 16);
    color[1] = parseInt((this.trim(hex)).substring(2, 4), 16);
    color[2] = parseInt((this.trim(hex)).substring(4, 6), 16);
    return color;
  }

  _objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }
    return target;
  }
}
